module.exports = __webpack_public_path__ + "static/media/moon.3f57c2da.svg";